var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDirectionsCar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 50 50"
}, props), /*#__PURE__*/React.createElement("mask", {
  width: 50,
  height: 50,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h50v50H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6C6C6C",
  d: "M10.898 37.5v3.125q0 .442-.3.742t-.742.3h-.48q-.444 0-.743-.3-.3-.3-.3-.742V25.32l4.135-11.778q.152-.497.587-.77.434-.272.968-.272h22.115q.474 0 .859.287.386.285.535.755l4.135 11.778v15.305q0 .442-.3.742t-.742.3h-.48q-.443 0-.743-.3t-.3-.742V37.5zm.385-14.263h27.435l-3.069-8.654H14.351zm4.191 9.455q.972 0 1.643-.68a2.27 2.27 0 0 0 .672-1.653q0-.972-.681-1.643a2.27 2.27 0 0 0-1.653-.671 2.22 2.22 0 0 0-1.643.68 2.27 2.27 0 0 0-.67 1.653q0 .972.68 1.643.68.672 1.652.671m19.071 0a2.22 2.22 0 0 0 1.643-.68q.67-.681.671-1.653a2.22 2.22 0 0 0-.68-1.643 2.27 2.27 0 0 0-1.653-.671q-.972 0-1.643.68a2.27 2.27 0 0 0-.671 1.653q0 .972.68 1.643.681.672 1.653.671m-24.128 2.725h29.167V25.32H10.417z"
}))));
export default SvgDirectionsCar;